(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-documents-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-support-documents]').forEach((section) => {
    const documents = Array.from(section.querySelectorAll('[data-document]'));
    const search = section.querySelector('[data-document-search]');
    const searchForm = search?.closest('form');
    const noResults = section.querySelector('[data-no-results]');
    const list = section.querySelector('[data-document-list]');
    const finderForm = section.querySelector('[data-finder-form]');
    const lineSelect = section.querySelector('[data-filter-line]');
    const typeSelect = section.querySelector('[data-filter-type]');
    const modelSelect = section.querySelector('[data-filter-model]');
    const viewButton = section.querySelector('[data-view-documents]');

    const normalizeSearch = (value) => value
      .toLowerCase()
      .replace(/z[\s-]?max/g, 'zmax')
      .replace(/z[\s-]?pro/g, 'zpro')
      .replace(/multi[\s-]?(split|zone)/g, 'multizone')
      .replace(/installation guide/g, 'installation manual')
      .replace(/specification sheet/g, 'spec sheet')
      .replace(/air handler/g, 'ahu')
      .replace(/rooftop unit/g, 'rtu')
      .replace(/12[,\s]?000\s*btu/g, '12k')
      .replace(/18[,\s]?000\s*btu/g, '18k')
      .replace(/24[,\s]?000\s*btu/g, '24k')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

    const showDocuments = (predicate) => {
      let visible = 0;
      documents.forEach((document) => {
        const show = predicate(document);
        document.hidden = !show;
        if (show) visible += 1;
      });
      list.hidden = visible === 0;
      noResults.hidden = visible !== 0;
    };

    const clear = () => {
      if (search) search.value = '';
      if (lineSelect) lineSelect.value = '';
      if (typeSelect) typeSelect.value = '';
      if (modelSelect) modelSelect.value = '';
      if (viewButton) viewButton.disabled = true;
      showDocuments(() => true);
    };

    searchForm?.addEventListener('submit', (event) => {
      event.preventDefault();
      const term = normalizeSearch(search.value);
      showDocuments((document) => !term || normalizeSearch(document.dataset.search).includes(term));
      section.querySelector('[data-document-list]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    search?.addEventListener('input', () => {
      const term = normalizeSearch(search.value);
      showDocuments((document) => !term || normalizeSearch(document.dataset.search).includes(term));
    });

    section.querySelectorAll('[data-category-filter]').forEach((link) => {
      link.addEventListener('click', () => {
        const category = link.dataset.categoryFilter;
        showDocuments((document) => document.dataset.category === category);
      });
    });

    section.querySelector('[data-clear-filters]')?.addEventListener('click', clear);

    [lineSelect, typeSelect, modelSelect].forEach((select) => {
      select?.addEventListener('change', () => {
        viewButton.disabled = !(lineSelect.value && typeSelect.value && modelSelect.value);
      });
    });

    finderForm?.addEventListener('submit', (event) => {
      event.preventDefault();
      const line = lineSelect.value;
      const type = typeSelect.value;
      const model = modelSelect.value;
      showDocuments((document) => {
        const lineMatches = line === 'all' || document.dataset.line === line || document.dataset.line === 'all';
        const typeMatches = document.dataset.type === type;
        const modelMatches = model === 'all' || document.dataset.model === model || document.dataset.model === 'all';
        return lineMatches && typeMatches && modelMatches;
      });
      section.querySelector('[data-document-list]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zero-home-app-page"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.zero-app__faq-toggle').forEach((button)=>{button.addEventListener('click',()=>{const section=button.closest('.zero-app__faq');const expanded=section.classList.toggle('is-expanded');button.setAttribute('aria-expanded',String(expanded));button.textContent=expanded?'Show Fewer FAQs':'View All FAQs';});});
document.querySelectorAll('.zero-app').forEach((app)=>{const modal=app.querySelector('[data-setup-video-modal]');const open=app.querySelector('[data-setup-video-open]');if(!modal||!open)return;const video=modal.querySelector('video');const close=()=>{modal.hidden=true;document.body.style.overflow='';if(video)video.pause();open.focus();};open.addEventListener('click',()=>{modal.hidden=false;document.body.style.overflow='hidden';const closeButton=modal.querySelector('.zero-app__video-close');if(closeButton)closeButton.focus();});modal.querySelectorAll('[data-setup-video-close]').forEach((button)=>button.addEventListener('click',close));document.addEventListener('keydown',(event)=>{if(event.key==='Escape'&&!modal.hidden)close();});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zero-showrooms-overview"] && !Shopify.designMode) return;
  try {
    
  const showroomLocations = [
    { id: 'san-jose', name: 'San Jose', latitude: 37.4036272, longitude: -121.9013473, address: '1560 Montague Expy, San Jose, CA 95131', mapUrl: 'https://www.google.com/maps/place/Zero+Bay+Area/@37.4021649,-121.901584,17z/data=!3m1!4b1!4m6!3m5!1s0x808fcff28441148d:0xbe7b3feaa513e2fa!8m2!3d37.4021649!4d-121.901584!16s%2Fg%2F11nvdg523_' },
    { id: 'milpitas', name: 'Milpitas', latitude: 37.4497285, longitude: -121.9204568, address: '1421 California Circle, Milpitas, CA 95035', mapUrl: 'https://www.google.com/maps/place/Zero+Bay+Area/@37.4497518,-121.9203973,17z/data=!3m1!4b1!4m6!3m5!1s0x808fc932f2e045df:0x3adfbbe57e8bcbd6!8m2!3d37.4497518!4d-121.9203973!16s%2Fg%2F11zyrxlj9t' },
    { id: 'south-san-francisco', name: 'South San Francisco', latitude: 37.6470221, longitude: -122.4202364, address: '245 S Spruce Ave #100, South San Francisco, CA 94080', mapUrl: 'https://www.google.com/maps/place/Zero+Bay+Area/@37.6454027,-122.4194863,17z/data=!3m1!4b1!4m6!3m5!1s0x808f7936d108566f:0xcfd88d8424ff2df6!8m2!3d37.6454027!4d-122.4194863!16s%2Fg%2F11zxmst8s_' },
    { id: 'hayward', name: 'Hayward', latitude: 37.6297851, longitude: -122.1133212, address: '26250 Corporate Ave, Hayward, CA 94545', mapUrl: 'https://www.google.com/maps/place/Zero+Bay+Area/@37.6298095,-122.1131131,17z/data=!3m1!4b1!4m6!3m5!1s0x808f97f8409a86bf:0x393e4a62d7a66bed!8m2!3d37.6298095!4d-122.1131131!16s%2Fg%2F11nw13jsc2' }
  ];

  let showroomMapState = null;
  let leafletLoader = null;

  const loadShowroomMapLibrary = (source) => {
    if (window.L) return Promise.resolve(window.L);
    if (leafletLoader) return leafletLoader;
    leafletLoader = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = source;
      script.onload = () => resolve(window.L);
      script.onerror = () => reject(new Error('map-library-failed'));
      document.head.append(script);
    });
    return leafletLoader;
  };

  const setShowroomMapActive = (id, moveMap = false) => {
    document.querySelectorAll('[data-location-row]').forEach((row) => row.classList.toggle('is-active', row.dataset.locationRow === id));
    if (!showroomMapState) {
      const mapCanvas = document.querySelector('[data-showroom-map]');
      if (mapCanvas) mapCanvas.dataset.pendingLocation = id;
      return;
    }
    showroomMapState.markers.forEach((marker, markerId) => {
      marker.getElement()?.classList.toggle('is-active', markerId === id);
    });
    const selectedMarker = showroomMapState.markers.get(id);
    if (selectedMarker && moveMap) {
      showroomMapState.map.flyTo(selectedMarker.getLatLng(), 12, { duration: 0.7 });
      selectedMarker.openPopup();
    }
  };

  const initializeShowroomMap = async (mapCanvas) => {
    if (showroomMapState || mapCanvas.dataset.loading === 'true') return;
    mapCanvas.dataset.loading = 'true';
    const mapShell = mapCanvas.closest('[data-showroom-map-shell]');
    const loadingMessage = mapShell?.querySelector('[data-map-loading]');
    try {
      const L = await loadShowroomMapLibrary(mapCanvas.dataset.leafletSrc);
      const map = L.map(mapCanvas, { scrollWheelZoom: false, zoomControl: true });
      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors'
      }).addTo(map);

      const markers = new Map();
      const bounds = [];
      showroomLocations.forEach((location, index) => {
        const icon = L.divIcon({
          className: 'zero-map-marker',
          html: `<span class="zero-map-marker__pin">${index + 1}</span><span class="zero-map-label">${location.name}</span>`,
          iconSize: [44, 64],
          iconAnchor: [17, 42],
          popupAnchor: [0, -42]
        });
        const popup = document.createElement('div');
        const name = document.createElement('strong');
        const address = document.createElement('span');
        popup.className = 'zero-map-popup';
        name.textContent = location.name;
        address.textContent = location.address;
        popup.append(name, address);
        const marker = L.marker([location.latitude, location.longitude], { icon, title: location.name, keyboard: true })
          .addTo(map)
          .bindPopup(popup);
        marker.on('click', () => setShowroomMapActive(location.id));
        markers.set(location.id, marker);
        bounds.push([location.latitude, location.longitude]);
      });

      map.fitBounds(bounds, { padding: [58, 58], maxZoom: 11 });
      showroomMapState = { map, markers };
      mapShell?.classList.add('is-map-ready');
      const initialLocation = mapCanvas.dataset.pendingLocation || 'san-jose';
      setShowroomMapActive(initialLocation, Boolean(mapCanvas.dataset.pendingLocation));
      window.setTimeout(() => map.invalidateSize(), 100);
    } catch (error) {
      mapShell?.classList.add('is-map-error');
      if (loadingMessage) loadingMessage.lastChild.textContent = 'Map temporarily unavailable';
    }
  };

  document.querySelectorAll('[data-showroom-map]').forEach((mapCanvas) => {
    if (!('IntersectionObserver' in window)) {
      initializeShowroomMap(mapCanvas);
      return;
    }
    const mapObserver = new IntersectionObserver((entries, observer) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      initializeShowroomMap(mapCanvas);
    }, { rootMargin: '500px 0px' });
    mapObserver.observe(mapCanvas);
  });

  const distanceInMiles = (latitudeA, longitudeA, latitudeB, longitudeB) => {
    const toRadians = (degrees) => degrees * Math.PI / 180;
    const latitudeDelta = toRadians(latitudeB - latitudeA);
    const longitudeDelta = toRadians(longitudeB - longitudeA);
    const calculation = Math.sin(latitudeDelta / 2) ** 2
      + Math.cos(toRadians(latitudeA)) * Math.cos(toRadians(latitudeB)) * Math.sin(longitudeDelta / 2) ** 2;
    return 3958.8 * 2 * Math.atan2(Math.sqrt(calculation), Math.sqrt(1 - calculation));
  };

  const showroomZipCoordinates = new Map(showroomLocations.map((location) => {
    const zipCode = location.address.match(/\b\d{5}\b/)?.[0];
    return [zipCode, { latitude: location.latitude, longitude: location.longitude }];
  }));

  const bayAreaFallbackLocation = (zipCode) => {
    const prefix = zipCode.slice(0, 3);
    if (prefix === '951') return 'san-jose';
    if (prefix === '950') return 'milpitas';
    if (['940', '941', '943', '944', '949'].includes(prefix)) return 'south-san-francisco';
    if (['945', '946', '947', '948'].includes(prefix)) return 'hayward';
    return null;
  };

  const lookupZipCoordinates = async (zipCode) => {
    const localCoordinates = showroomZipCoordinates.get(zipCode);
    if (localCoordinates) return localCoordinates;

    const bayAreaCoordinates = window.ZeroBayAreaZipCoordinates?.[zipCode];
    if (Array.isArray(bayAreaCoordinates)) {
      return { latitude: bayAreaCoordinates[0], longitude: bayAreaCoordinates[1] };
    }

    const fallbackLocationId = bayAreaFallbackLocation(zipCode);
    if (fallbackLocationId) return { locationId: fallbackLocationId };

    const cacheKey = `zero-showroom-zip-${zipCode}`;
    try {
      const cachedCoordinates = JSON.parse(window.sessionStorage.getItem(cacheKey));
      if (Number.isFinite(cachedCoordinates?.latitude) && Number.isFinite(cachedCoordinates?.longitude)) return cachedCoordinates;
    } catch (error) {
      window.sessionStorage.removeItem(cacheKey);
    }

    const controller = new AbortController();
    const requestTimeout = window.setTimeout(() => controller.abort(), 2500);
    try {
      const response = await fetch(`https://api.zippopotam.us/us/${zipCode}`, { signal: controller.signal });
      if (!response.ok) throw new Error(response.status === 404 ? 'invalid-zip' : 'lookup-failed');
      const zipData = await response.json();
      const zipPlace = zipData.places?.[0];
      const coordinates = {
        latitude: Number.parseFloat(zipPlace?.latitude),
        longitude: Number.parseFloat(zipPlace?.longitude)
      };
      if (!Number.isFinite(coordinates.latitude) || !Number.isFinite(coordinates.longitude)) throw new Error('lookup-failed');
      try {
        window.sessionStorage.setItem(cacheKey, JSON.stringify(coordinates));
      } catch (error) {
        return coordinates;
      }
      return coordinates;
    } catch (error) {
      if (error.name === 'AbortError') throw new Error('lookup-timeout');
      throw error;
    } finally {
      window.clearTimeout(requestTimeout);
    }
  };

  const showFinderMessage = (status, message, link) => {
    if (!status) return;
    status.replaceChildren();
    status.classList.toggle('is-result', Boolean(link));
    if (!link) {
      status.textContent = message;
      return;
    }
    const label = document.createElement('strong');
    const anchor = document.createElement('a');
    label.textContent = message;
    anchor.href = link.href;
    anchor.textContent = link.label;
    status.append(label, anchor);
  };

  document.querySelectorAll('[data-showroom-finder]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const input = form.querySelector('input[name="zip"]');
      const button = form.querySelector('button[type="submit"]');
      const status = form.closest('.zero-showrooms__hero-copy')?.querySelector('[data-showroom-status]');
      const zipCode = input.value.trim();
      if (!/^\d{5}$/.test(zipCode)) {
        showFinderMessage(status, 'Enter a valid five-digit ZIP code.', null);
        input.focus();
        return;
      }

      button.disabled = true;
      button.textContent = 'Finding…';
      showFinderMessage(status, 'Finding the closest Bay Area location…', null);
      const map = document.querySelector('.zero-showrooms__map');
      const mapResult = map?.querySelector('[data-map-result]');
      map?.classList.remove('has-search-result');
      if (mapResult) mapResult.hidden = true;
      try {
        const lookupResult = await lookupZipCoordinates(zipCode);
        const nearest = lookupResult.locationId
          ? { ...showroomLocations.find((location) => location.id === lookupResult.locationId), distance: null }
          : showroomLocations
            .map((location) => ({ ...location, distance: distanceInMiles(lookupResult.latitude, lookupResult.longitude, location.latitude, location.longitude) }))
            .sort((locationA, locationB) => locationA.distance - locationB.distance)[0];
        const distanceMessage = Number.isFinite(nearest.distance) ? ` · about ${nearest.distance.toFixed(1)} miles` : '';
        const nearestRow = document.querySelector(`[data-location-row="${nearest.id}"]`);
        setShowroomMapActive(nearest.id, true);
        showFinderMessage(status, `Nearest location: ${nearest.name}${distanceMessage}`, { href: `#${nearest.id}`, label: 'View location' });
        if (map && mapResult) {
          mapResult.querySelector('[data-map-zip]').textContent = zipCode;
          mapResult.querySelector('[data-map-location]').textContent = nearest.name;
          mapResult.querySelector('[data-map-distance]').textContent = Number.isFinite(nearest.distance) ? `About ${nearest.distance.toFixed(1)} miles away` : 'Nearest Bay Area location';
          mapResult.querySelector('[data-map-directions]').href = nearest.mapUrl;
          mapResult.hidden = false;
          map.classList.add('has-search-result');
        }

        window.setTimeout(() => {
          document.querySelector('.zero-showrooms__location-panel')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          nearestRow?.focus({ preventScroll: true });
        }, 250);
      } catch (error) {
        if (error.message === 'invalid-zip') {
          showFinderMessage(status, 'ZIP code not found. Check the number and try again.', null);
          input.focus();
        } else {
          showFinderMessage(status, 'ZIP lookup is temporarily unavailable.', { href: '#showroom-locations', label: 'Choose from all locations' });
        }
      } finally {
        button.disabled = false;
        button.textContent = 'Find Nearest Location';
      }
    });
  });

  document.querySelectorAll('[data-showroom-experience]').forEach((experience) => {
    const stage = experience.querySelector('[data-showroom-video-stage]');
    const video = experience.querySelector('[data-showroom-video]');
    const watch = experience.querySelector('[data-showroom-watch]');
    const soundToggle = experience.querySelector('[data-showroom-video-status]');
    const soundLabel = experience.querySelector('[data-showroom-sound-label]');
    const dialog = experience.querySelector('[data-showroom-dialog]');
    const dialogVideo = experience.querySelector('[data-showroom-dialog-video]');
    const dialogClose = experience.querySelector('[data-showroom-dialog-close]');
    const rows = experience.querySelectorAll('[data-location-row]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const loadVideo = () => {
      if (video.src) return;
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      const lowBandwidth = connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType));
      if (lowBandwidth) {
        video.src = video.dataset.srcLow;
      } else if (window.matchMedia('(max-width: 699px)').matches) {
        video.src = video.dataset.srcMobile;
      } else {
        video.src = video.dataset.src;
      }
      video.load();
    };

    const playVideo = () => {
      loadVideo();
      video.play().then(() => stage.classList.add('is-playing')).catch(() => stage.classList.remove('is-playing'));
    };

    const updateSoundToggle = () => {
      soundToggle.setAttribute('aria-pressed', String(!video.muted));
      soundToggle.setAttribute('aria-label', video.muted ? 'Unmute background video' : 'Mute background video');
      soundLabel.textContent = video.muted ? 'Unmute background' : 'Mute background';
    };

    video.addEventListener('volumechange', updateSoundToggle);
    video.addEventListener('play', () => stage.classList.add('is-playing'));
    video.addEventListener('pause', () => stage.classList.remove('is-playing'));

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (!reduceMotion) playVideo();
        } else {
          video.pause();
          stage.classList.remove('is-playing');
        }
      });
    }, { rootMargin: '280px 0px', threshold: 0.08 });

    observer.observe(stage);

    watch.addEventListener('click', () => {
      loadVideo();
      video.pause();
      video.muted = true;
      dialogVideo.src = video.currentSrc || video.src;
      dialogVideo.currentTime = 0;
      dialogVideo.muted = false;
      dialog.showModal();
      dialogVideo.play().catch(() => {});
    });

    soundToggle.addEventListener('click', () => {
      video.muted = !video.muted;
      updateSoundToggle();
    });

    dialogClose.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => {
      dialogVideo.pause();
      dialogVideo.currentTime = 0;
      if (!reduceMotion && stage.getBoundingClientRect().bottom > 0 && stage.getBoundingClientRect().top < window.innerHeight) playVideo();
      watch.focus();
    });

    const activateLocation = (id) => {
      setShowroomMapActive(id);
    };

    rows.forEach((row) => {
      row.addEventListener('mouseenter', () => activateLocation(row.dataset.locationRow));
      row.addEventListener('focusin', () => activateLocation(row.dataset.locationRow));
    });

  });

  } catch(e) { console.error(e); }
})();
})();
